<template>
  <bill-template-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateBillTemplate } from '@/services/bill_template.service'
import billTemplateBlankForm from '@/components/forms/bill_template/BillTemplateBlankForm'

export default {
  name: 'bill-template-edit-form',
  components: { billTemplateBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        bill_template: {
          id: [],
          file: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processForm () {
      this.updateBillTemplate().then((success) => {
        if (success) {
          this.showMsg('Информация была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateBillTemplate () {
      return updateBillTemplate(this.$attrs['bill-template']).then((response) => {
        this.fillErrors(this.errors.bill_template, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.bill_template, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BillTemplateEditForm.vue?0e001f1b